<template>
    <div
        :class="['stage-status', {
            'active-stage': active,
            'complete-stage': complete,
            'invalid-stage': invalid,
            'disabled-stage': stage.disabled,
        }]"
    >
        <ds-popover
            class="error-tooltip"
            block-body-close
            :is-open="!!stage.showError"
        >
            <template #reference>
                <div
                    v-if="activeOrInProgress"
                    :class="['stage-icon', { active, invalid }]"
                    @click="goToStage"
                >
                    <span>{{ stageNumber }}</span>
                </div>

                <div
                    v-else
                    :class="['stage-icon icon-only', { complete, invalid }]"
                    @click="goToStage"
                >
                    <ds-icon :name="inactiveIcon" />
                </div>
            </template>

            <template #default>
                <span class="error-tooltip-text">{{ stage.errorTooltip }}</span>
            </template>
        </ds-popover>

        <span class="label stage-label">{{ stage.label }}</span>
    </div>
</template>

<script>
import { STAGE_STATUS } from '@/components/broadcast/constants/smsBroadcast.constants';

export default {
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        stage: {
            type: Object,
            required: true,
        },
        stageNumber: {
            type: Number,
            required: true,
        },
    },

    computed: {
        activeOrInProgress() {
            return this.active || this.inProgress;
        },

        complete() {
            return this.stage.status === STAGE_STATUS.COMPLETE;
        },

        inactiveIcon() {
            return this.invalid ? 'alert-triangle-fill' : 'check';
        },

        inProgress() {
            return this.stage.status === STAGE_STATUS.IN_PROGRESS;
        },

        invalid() {
            return this.stage.status === STAGE_STATUS.INVALID;
        },
    },

    methods: {
        goToStage() {
            this.$emit('go-to-stage');
        },
    },
};
</script>

<style lang="scss" scoped>
    $stage-icon-size: px-to-rem(26px);
    $tooltip-width: px-to-rem(200px);

    .stage-status {
        padding: 0 $spacing-400;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        @media($small) {
            padding: 0 0.33rem;
        }

        &:not(.disabled-stage) {
            cursor: pointer;
        }

        &:not(:last-child) {
            &:after {
                content: "";
                width: calc(100% - #{$stage-icon-size});
                border: 1px solid $color-gray-200;
                @include position(absolute px-to-rem(12px) auto auto calc(50% + #{calc($stage-icon-size / 2)}));
            }

            &.complete-stage:after {
                border: 1px solid $color-blue;
            }

            &.invalid-stage:after {
                border: 1px dashed $color-red;
            }
        }
    }

    .error-tooltip {
        height: $stage-icon-size;
        --popover-width: #{$tooltip-width};
        --popover-min-width: #{$tooltip-width};

        &-text {
            display: flex;
            @include text-align-start;
            line-height: 1.5;
            padding: $spacing-200;

        }
    }

    .stage-icon {
        @include circle($stage-icon-size);
        border: solid 2px $color-gray-200;
        z-index: 1;
        background-color: $color-paper;
        height: $stage-icon-size;
        width: $stage-icon-size;

        &.active {
            border-color: $color-blue;
        }

        &.invalid {
            border-color: $color-red;
        }
    }

    .icon-only {
        &.complete {
            border-color: $color-blue;
            background-color: $color-blue;

            --icon-color: #{$color-paper};
            --icon-size: #{$icon-size-small};
        }

        &.invalid {
            border: none;

            --icon-color: #{$color-red};
            --icon-size: #{$stage-icon-size};
        }
    }

    .label {
        padding: 0 $spacing-050;
        background-color: $color-paper;
        color: $color-gray-800;
        z-index: 1;

        @media($small) {
            display: none;
        }
    }

    .active-stage .label {
        color: $color-gray-900;
        font-weight: $font-weight-semibold;
    }

    .invalid-stage .label {
        color: $color-red;
    }
    .stage-label {
        font-size: 0.875rem;
    }
</style>
